import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, TableLoader, InputWithIcon, getBank, toast } from '@livable/saas-react-components';
import { Paper, Typography, Button, TableContainer, Table, TableBody, TextField, TableHead, TableRow, TableCell } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PayGateModal } from 'src/components/utilities/PayGateModal';
import AssignPaymentMethodModal from 'src/components/settings/AssignPaymentMethodModal';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const PaymentMethodsGrid = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    paymentMethods = _useState4[0],
    setPaymentMethods = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewMethodAdded = _useState6[0],
    setIsNewMethodAdded = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchKey = _useState8[0],
    setSearchKey = _useState8[1];
  const deletePaymentMethod = async id => {
    const resp = await store.payment.deletePaymentMethodAsync.run(id);
    return resp;
  };
  const getFilteredData = () => paymentMethods.filter(p => {
    const searchPhrase = new RegExp(searchKey, 'gi');
    return searchKey.length > 0 ? " ".concat(p.last4).search(searchPhrase) > 0 || " ".concat(p.brand).search(searchPhrase) > 0 : true;
  });
  const fetchData = async () => {
    setIsLoading(true);
    const getAutopayMethod = async () => {
      const resp = await store.payment.getAutopayMethodAsync.run();
      return resp;
    };
    const getPaymentMethods = async () => {
      const resp = await store.payment.getPaymentMethodsV2Async.run({
        applyToHomeDashboard: false
      });
      return resp;
    };
    const getCompanyProperties = async () => {
      const resp = await store.company.getCompanyPropertiesAsync.run();
      return resp;
    };
    let promises = [getAutopayMethod(), getPaymentMethods(), getCompanyProperties()];
    Promise.all([...promises]).then(resp => {
      if (resp && resp[1] && resp[1].response) {
        let result = [];
        const paymentMethodsResp = resp[1].response;
        const companyProps = resp[2].response;
        paymentMethodsResp.map(item => {
          const exposedProperties = item.assignedPropertyIds.map(propertyId => companyProps.find(p => p.propertyId === propertyId) || undefined).filter(p => !!p);
          const obj = _objectSpread(_objectSpread({}, item), {}, {
            assignedProperties: [...exposedProperties]
          });
          obj.isAutoPayMethod = () => {
            var _store$payment$autopa;
            return ((_store$payment$autopa = store.payment.autopayMethod) === null || _store$payment$autopa === void 0 ? void 0 : _store$payment$autopa.id) === obj.id;
          };
          result.push(obj);
        });
        setPaymentMethods(result);
      }
    }).finally(() => setIsLoading(false));
  };
  useEffect(() => {
    fetchData();
    if (isNewMethodAdded) {
      fetchData();
      setIsNewMethodAdded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewMethodAdded]);
  const handleDelete = method => {
    if (method.assignedPropertyIds.length && paymentMethods.length > 1) {
      toast('warning', {
        body: ['This payment method is already assigned to the property'] // ? i18n
      });
    } else {
      if (method.id) {
        const paymentMethodId = method.id;
        setIsLoading(true);
        deletePaymentMethod({
          paymentMethodId
        }).then(resp => {
          if (resp && resp.isSuccessful) {
            store.payment.updatePaymentMethodsAfterDelete({
              paymentMethodId
            });
            toast('success', {
              body: ['Payment method have been removed']
            }); // ? i18n
          }
        }).finally(() => setIsLoading(false));
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('subscriptions.payment_methods')), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(PayGateModal, {
    newMethodAdded: setIsNewMethodAdded,
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      size: "large",
      variant: "priority",
      'custom-attribute': '30-payments-page-payment-methods'
    }, t('subscriptions.add_new_payment_method'))
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.searchSection
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    size: "small",
    className: classes.searchSectionInput,
    value: searchKey,
    onChange: event => setSearchKey(event.target.value),
    fullWidth: true,
    placeholder: t('subscriptions.search_for_method')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.tableWrapper
  }, isLoading && /*#__PURE__*/React.createElement(TableLoader, null), !!paymentMethods.length && !!getFilteredData().length && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    width: '500px',
    align: "left"
  }, t('subscriptions.payment_information')), /*#__PURE__*/React.createElement(TableCell, {
    width: '420px',
    align: "left"
  }, t('subscriptions.number_of_properties')), /*#__PURE__*/React.createElement(TableCell, {
    width: '120px',
    align: "left"
  }, ''))), /*#__PURE__*/React.createElement(TableBody, null, !!getFilteredData().length && getFilteredData().map(method => /*#__PURE__*/React.createElement(TableRow, {
    key: method.id
  }, /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      display: 'inline',
      verticalAlign: 'middle'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: getBank(method.brand).logo,
    width: "46",
    height: "28",
    alt: "bank logo"
  })), /*#__PURE__*/React.createElement("span", null, getBank(method.brand).title, "\xA0", t('subscriptions.ending_in'), " \u2022\u2022\u2022\u2022\u2006", method.last4)), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, method.assignedProperties.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " cellContent")
  }, method.assignedProperties.length + ' properties')), method.assignedProperties.length === 0 && /*#__PURE__*/React.createElement(AssignPaymentMethodModal, {
    selectedPaymentMethod: method,
    triggerRefresh: fetchData,
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      size: "small"
      // onClick={() => track(events.modalOpened('Enroll Resident'))}
      ,
      'custom-attribute': '705-payments-page'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    }), t('subscriptions.assign_to_properties'))
  }))), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      handleDelete(method);
    },
    variant: "actionButton",
    'custom-attribute': '706-payments-page'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.remove'))))))))), !!paymentMethods.length && !getFilteredData().length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Found"
  }), !paymentMethods.length && /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No Data Available"
  })));
});
PaymentMethodsGrid.propTypes = {};